"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvroReadableFromStream = exports.AvroReadable = exports.AvroReader = void 0;
var AvroReader_js_1 = require("./AvroReader.js");
Object.defineProperty(exports, "AvroReader", { enumerable: true, get: function () { return AvroReader_js_1.AvroReader; } });
var AvroReadable_js_1 = require("./AvroReadable.js");
Object.defineProperty(exports, "AvroReadable", { enumerable: true, get: function () { return AvroReadable_js_1.AvroReadable; } });
var AvroReadableFromStream_js_1 = require("./AvroReadableFromStream.js");
Object.defineProperty(exports, "AvroReadableFromStream", { enumerable: true, get: function () { return AvroReadableFromStream_js_1.AvroReadableFromStream; } });
//# sourceMappingURL=index.js.map